import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const createVideoInStories = isFeature('create-video-in-stories');
